import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRACTICE_AREAS } from "../data/firmContent";
import useSEO from "../lib/useSEO";

export default function PracticeAreas() {
    useSEO({ title: "Practice Areas", description: "Six disciplines, one standard — criminal prosecution, civil litigation, commercial litigation, arbitration, IP, real estate.", path: "/practice-areas" });
    return (
        <div data-testid="page-practice-areas">
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24">
                <div className="font-mono-cap text-xs text-[#c5a059] mb-3">Practice Areas</div>
                <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-tight">
                    Six disciplines. One standard.
                </h1>
                <p className="mt-6 max-w-2xl text-slate-800 leading-relaxed text-[17px]">
                    From criminal prosecution to corporate advisory, our partners and associates bring three decades of
                    combined trial-floor and boardroom experience to bear on every brief.
                </p>
            </section>

            <section className="bg-[#f3f1ea] border-y border-slate-900/10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12">
                        {PRACTICE_AREAS.map((p) => (
                            <Link
                                key={p.slug}
                                to={`/practice-areas/${p.slug}`}
                                className="group block bg-[#faf9f6] border border-slate-900/10 hover:border-[#c5a059] transition-colors"
                                data-testid={`practice-list-card-${p.slug}`}
                            >
                                <div className="relative h-56 overflow-hidden">
                                    <img
                                        src={p.image}
                                        alt={p.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                    <div className="absolute top-4 left-4 bg-[#0F172A] text-[#c5a059] font-mono-cap text-[10px] px-3 py-1">
                                        {p.kicker}
                                    </div>
                                </div>
                                <div className="p-8">
                                    <h2 className="font-serif-display text-2xl md:text-3xl text-slate-900">{p.title}</h2>
                                    <p className="mt-4 text-[15px] text-slate-800 leading-relaxed">{p.short}</p>
                                    <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-slate-900 border-b border-[#c5a059] pb-1">
                                        Read more <ArrowUpRight className="w-4 h-4" />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
